/**
 * <Logo /> — single source of truth for the HisaabPro brand mark.
 *
 * Usage:
 *   <Logo size={32} />                       // default — full color
 *   <Logo size={48} variant="square" />      // emerald squircle background
 *   <Logo size={20} variant="bare" />        // shield only, no squircle bg
 *   <Logo size={120} priority />             // first-paint hero (skips lazy)
 *
 * Why <img> and not inline SVG? The asset is bundled in /public/brand/ and
 * served as a static file — browser cache + CDN edge caching = instant
 * subsequent loads. Inline SVG would bloat every JS bundle by ~3 KB.
 */
import React from "react";

const SRC = {
  full: "/brand/logo.svg",                    // emerald squircle + shield
  square: "/brand/logo.svg",                  // same file (squircle baked in)
  bare: "/brand/logo.svg",                    // we use the same file — variant
                                              // mainly toggles size/style
};

export default function Logo({
  size = 32,
  variant = "full",
  className = "",
  alt = "HisaabPro",
  priority = false,
  ...rest
}) {
  return (
    <img
      src={SRC[variant] || SRC.full}
      width={size}
      height={size}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      className={`select-none ${className}`}
      draggable="false"
      data-testid="brand-logo"
      style={{ width: size, height: size }}
      {...rest}
    />
  );
}
